module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "totalSlide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shown),
      expression: "shown"
    }],
    staticClass: "billcount-detail-total",
    staticStyle: {
      "background": "#fff"
    },
    on: {
      "click": _vm.moveAni
    }
  }, [_c('p', {
    staticClass: "total-company-date"
  }, [(_vm.filter.date_type === '0' && _vm.filter.bill_state !== 20 && _vm.filter.bill_state !== 21) ? _c('span', [_vm._v("订货日期：")]) : _vm._e(), _vm._v(" "), (_vm.filter.date_type === '0' && (_vm.filter.bill_state === 20 || _vm.filter.bill_state === 21)) ? _c('span', [_vm._v("退货日期：")]) : _vm._e(), _vm._v(" "), (_vm.filter.date_type === '1') ? _c('span', [_vm._v("到货日期：")]) : _vm._e(), _vm._v("\n\t\t\t\t" + _vm._s(_vm.totalSum.startDate) + " 到 " + _vm._s(_vm.totalSum.endDate) + "\n\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "total-company-name"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalSum.goods_name))])]), _vm._v(" "), (_vm.goods_num) ? _c('p', {
    staticClass: "total-company-p"
  }, [_vm._v("订货金额合计：" + _vm._s(_vm.goods_num) + " 元")]) : _vm._e(), _vm._v(" "), (_vm.goods_num_send) ? _c('p', {
    staticClass: "total-company-p"
  }, [_vm._v("发货金额合计：" + _vm._s(_vm.goods_num_send) + " 元")]) : _vm._e(), _vm._v(" "), (_vm.sub_total) ? _c('p', {
    staticClass: "total-company-p"
  }, [_vm._v("收货金额合计：" + _vm._s(_vm.sub_total) + " 元")]) : _vm._e(), _vm._v(" "), (_vm.filter.bill_state === 20 || _vm.filter.bill_state === 21) ? _c('p', {
    staticClass: "total-company-p"
  }, [_vm._v("退货数量合计：" + _vm._s(_vm.return_num))]) : _vm._e(), _vm._v(" "), (_vm.return_sub_total) ? _c('p', {
    staticClass: "total-company-p"
  }, [_vm._v("退货金额合计：" + _vm._s(_vm.return_sub_total) + " 元")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shown),
      expression: "!shown"
    }],
    staticClass: "edi-total-second",
    on: {
      "click": _vm.getTotal
    }
  }, [_vm._v("合计")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-571963bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetGoodsTotal.vue
// module id = 571
// module chunks = 1